// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, ViewEncapsulation, OnInit, ViewChild, AfterViewInit, OnDestroy, NgZone } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
// Class
import { MasterConstants } from '../../../../common/constants/master-constants';
import { FilterOption } from '../../../../common/components/filter/filter-model';
import { ControlType } from '../../../../common/components/filter/filter-enum';
import { CommonService } from './../../../../services/common/common.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
// Service Class
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { ExcelService } from './../../../../services/infrastructure/excel.service';
import { AssociateCropService } from './../../../../services/seed/associate-crop.service';
import { SliderModelService } from '../../../../services/infrastructure/sliderModel.service';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from './../../../../services/infrastructure/config.service';
import { AssociateCropReconciliationConfirmationComponent } from '../associate-crop-reconciliation-confirmation/associate-crop-reconciliation-confirmation.component';
import { ConfirmDialogComponent } from './../../../../common/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-associate-crop-reconciliation-landing',
  templateUrl: './associate-crop-reconciliation-landing.component.html',
  styleUrls: ['./associate-crop-reconciliation-landing.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AssociateCropReconciliationLandingComponent implements OnInit, AfterViewInit, OnDestroy {
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  validateEvolveData: any;
  ddlAccounts: any[] = [];
  userMenuAccessList: any;
  readOnlyAccess = false;

  hasChangeAdded = false;
  filterOptionsData: Array<FilterOption>;
  subscription = new Subscription();
  masterConstants = MasterConstants;
  associateDataSource: MatTableDataSource<any>;
  @ViewChild('associateTable', { read: MatSort }) associateSort: MatSort;
  @ViewChild('associatePaginator', { read: MatPaginator }) associatePaginator: MatPaginator;
  associateOrderColumns: string[] = [];
  filter: AssociateOrderLandingFilterVM = new AssociateOrderLandingFilterVM();
  isAllAccountsChecked: boolean;
  showTabs: boolean;
  checkBoxCount: number;
  tabNode: string;
  errorsList: Array<string> = [];
  error = false;
  showErrorBlock = false;
  index = 0;
  showUpdateDiv = false;
  isDisableUpdateButton = true;

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private localStorageService: LocalStorageService,
    private associateCropService: AssociateCropService,
    public excelService: ExcelService,
    private datePipe: DatePipe,
    private commonService: CommonService,
    private sliderModelService: SliderModelService,
    public dialog: MatDialog,
    private toastrService: ToastrService,
    private zone: NgZone
  ) {
    this.subscription.add(this.broadcastService.on<any>(this.configService.DATA_CHANGE_ADDED).subscribe((data) => {
      if (data.hasChangeAdded != undefined) {
        this.hasChangeAdded = data.hasChangeAdded;
      }
    }));
  }

  createNewReturn() {
    this.router.navigate(['/associate-crop/associate-crop-create-order']);
  }

  // ngOnInit
  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        this.userMenuAccessList = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).userMenuAccessList;
        const associateReconsileAccess = data.resultData.find(x => x.userIdCompanyCode == MasterConstants.US_COMPANYCODE).associateReconciliationAccess;
        if (this.commonService.checkUserRoleAccessTypeForMenu(this.userMenuAccessList, MasterConstants.FUNCTION_CODE.CROP_ASSOCIATES_RECONCILIATION) && associateReconsileAccess) {
          this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.CROP_ASSOCIATES_RECONCILIATION, MasterConstants.USER_ACCESS.READ_ONLY, this.userMenuAccessList);
          if (this.headerYear) {
            this.setFilterAndGridColumn();
            this.setDefaultFilter();
            this.getGridData(true);
            this.addUpdateNewVariety();
          }
        } else {
          this.router.navigate(['/cc/landing-data']);
        }
      }
    }




  }


  addUpdateNewVariety() {
    this.subscription.add(
      this.sliderModelService.reconcileVarietySelected.subscribe(variety => {
        if (variety.length == 0) return;
        const data = this.associateDataSource?.data;
        let updatedRowId = this.associateDataSource?.data?.length;
        let insertIndex = this.index;
        variety.forEach(x => {
          const newRow = {
            ...data[this.index],          // copy all values
            isEditable: true,
            isSelected: true,
            brand: x.variety,
            orderUOM: x.uom,
            status: "Submitted",
            availableQuantity: x.availableQty,
            orderQty: x.orderQty,
            rowId: updatedRowId + 1,
            isNewLine: true,
            previousQty: x.orderQty,
            marketingBrand: x.marketingBrand,
            orderDetailID: 0,
            baseQty:0,
            preferredPackagingSize: x.preferredPackagingSize,
            approvalStatus: "Submitted",
            lineErrors: {
              'rowId': updatedRowId + 1, 'errors': []
            },
          };

          const rowToUpdate = this.associateDataSource.data?.find(
            r => r.orderHeaderID === newRow.orderHeaderID && r.brand === newRow.brand);

          if (rowToUpdate) {
            rowToUpdate.orderQty = x.orderQty;
            rowToUpdate.availableQuantity = x.availableQty;
            rowToUpdate.preferredPackagingSize = x.preferredPackagingSize;
            rowToUpdate.previousQty = x.orderQty;
            rowToUpdate.lineErrors.errors = [];
            this.associateDataSource.data = [...this.associateDataSource.data];

          } else {
            insertIndex++;
            data.splice(insertIndex, 0, newRow);

            this.associateDataSource.data = [...data];
          }
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { reconcileDataChanged: true, labelNo: 'No, go back to Order Reconciliation' });
          this.disableEnableUpdateBtn();
        });

      })
    );
  }

  showTab(tabid: string) {
    this.tabNode = tabid;
    tabid === 'Cancelled' ? this.cancelLineCheck() : this.approveLineCheck();
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.zone.onStable.subscribe(() => {
      this.setAccSummaryTableHeight();
    });
  }


  // set account table height
  setAccSummaryTableHeight() {
    setTimeout(function () {

      let templateHeight = window.innerHeight
        - $('.order-view-sec').outerHeight() 
        - $('.filtersData').outerHeight()
        - $('.mat-mdc-tab-header').outerHeight()
        - $('.fulfill-top-sec').outerHeight()
        - 150;

      // Include detail-row-container height only if element exists & has height
      const detailRow = $('.detail-row-container');
      if (detailRow.length && detailRow.outerHeight()) {
        templateHeight -= detailRow.outerHeight();
      }

      $('.activeReturnRequest').css('max-height', templateHeight + 'px');

    }, 100);
  }

  // Set Filter and Grid Columns
  setFilterAndGridColumn() {
    this.filterOptionsData = [
      { label: 'Account Name', key: 'accountNameList', controlType: ControlType.Text },
      { label: 'Account Number', key: 'accountNumberList', controlType: ControlType.Text },
      { label: 'Order Number', key: 'orderHeaderIdList', controlType: ControlType.Text },
      { label: 'Associate Location Name', key: 'locationNameList', controlType: ControlType.Text },
      { label: 'Crop Type', key: 'cropTypeCode', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id', isMultiSelect: false },
      { label: 'Variety', key: 'brandList', controlType: ControlType.Text },
      { label: 'Order Date', key: 'orderDate', controlType: ControlType.DateRange },
      { label: 'Status', key: 'status', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'id' },
    ];

    this.associateOrderColumns = ['checkbox', 'orderHeaderID', 'associateName', 'accountName', 'orderDate', 'brand', 'orderQty', 'orderUOM', 'status'];
  }

  // Set Drop down values for filter
  setDropDownValues(source) {
    const cropTypeList = this.getcropTypeList(source);
    if (cropTypeList && cropTypeList.length > 0) {
      this.filterOptionsData.find(x => x.key === 'cropTypeCode').controlData = cropTypeList;
    } else {
      this.filterOptionsData.find(x => x.key === 'cropTypeCode').controlData = [];
    }

    const statusTypeList = this.getStatusList(source);
    if (statusTypeList && statusTypeList.length > 0) {
      this.filterOptionsData.find(x => x.key === 'status').controlData = statusTypeList;
    } else {
      this.filterOptionsData.find(x => x.key === 'status').controlData = [];
    }
  }

  getcropTypeList(source) {
    let result = [];
    const seen = new Set();
    for (const item of source) {
      if (!seen.has(item.cropTypeCode)) {
        seen.add(item.cropTypeCode);
        result.push({ id: item.cropTypeCode, value: item.cropTypeDesc });
      }
    }
    result = result.sort((a, b) => a.value.localeCompare(b.value));
    return result;
  }

  getStatusList(source) {
    let result = [];
    const seen = new Set();
    for (const item of source) {
      if (!seen.has(item.status)) {
        seen.add(item.status);
        result.push({ id: item.status, value: item.status });
      }
    }
    result = result.sort((a, b) => a.value.localeCompare(b.value));
    return result;
  }
  // Set default filter values
  setDefaultFilter() {
    this.filter = {
      orderHeaderIdList: null,
      accountNumberList: null,
      accountNameList: null,
      locationNameList: null,
      cropTypeCode: null,
      brandList: null,
      orderFrom: null,
      orderTo: null,
      status: null
    };
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // get data for both tabs
  getGridData(isfirstimeload: boolean) {
    this.showTabs = false;
    this.isDisableUpdateButton = true;
    this.showUpdateDiv = false;
    this.isAllAccountsChecked = false;
    this.checkBoxCount = 0;
    this.loaderService.setLoaderStatus(true);
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, {
      updateButtonClick: true
    });
    this.subscription.add(this.associateCropService.GetSeedCropAssociatesReconciliationLandingData(this.filter).subscribe((result: any[]) => {
      const associateOrderList = result && result.length > 0
        ? result.map((item, index) => ({
          ...item,
          isSelected: item.isSelected ?? false,
          isNewLine: false,
          baseQty: item.orderQty,
          previousQty: item.orderQty,
          preferredPackagingSize: '',
          approvalStatus:  null,
          rowId: index + 1,
          lineErrors: {
            rowId: index + 1,
            errors: []
          }
        }))
        : [];

      if (isfirstimeload) {
        this.setDropDownValues(associateOrderList);
      }
      this.associateDataSource = new MatTableDataSource(associateOrderList);
      this.associateDataSource.paginator = this.associatePaginator;
      this.associateDataSource.paginator.firstPage();
      this.associateDataSource.sort = this.associateSort;
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  // Search Action
  filterSearchClick(event) {
    this.filter = event;
    this.getGridData(false);
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.filter = event;
    this.getGridData(false);
  }


  export() {
    const exportData = [];
    if (this.associateDataSource && this.associateDataSource.data.length > 0) {
      this.loaderService.setLoaderStatus(true);
      this.associateDataSource.data.forEach(x => {
        exportData.push({
          'Order Number': x.orderHeaderID,
          'Associate Location': x.associateName,
          'Associate City': x.associateCity,
          'Associate State': x.associateState,
          'Account Number': x.shipToAccount,
          'Account': x.accountName,
          'Account City': x.shipToCity,
          'Account State': x.shipToState,
          'Request By Date': this.datePipe.transform(x.orderDate, MasterConstants.DATE_MMDDYYYY),
          'Variety': x.brand,
          'Ordered Qty': x.orderQty,
          'UOM': x.orderUOM,
          'Status': x.status
        });
      });
      this.excelService.exportAsExcelFileWithDate(exportData, 'AssociateReconciliationOrder');
      this.loaderService.setLoaderStatus(false);
    }
  }

  //refreshScreen() {
  //  this.setDefaultFilter();
  //  this.getGridData(true);
  //}

  refreshScreen() {
    if (this.hasChangeAdded) {
      const title = 'Leave without saving?';
      const message = '';
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '480px',
        data: { title: title, message: message, labelYes: 'Yes', labelNo: 'No, go back to Order Reconciliation', dialogType: 'confirm' }
      });
      this.subscription.add(dialogRef.afterClosed().subscribe(result => {
        if (result == true) {
          this.broadcastService.broadcast(this.configService.DATA_CHANGE, { cancelBtnClick: true });
          this.sliderModelService.close();
          this.setDefaultFilter();
          this.getGridData(true);
        }
      }));
    }
    else {
      this.sliderModelService.close();
      this.setDefaultFilter();
      this.getGridData(true);
    }
  }

  approveLineCheck() {
    this.associateDataSource.data.filter(x => x.isEditable == true && x.isSelected == true && !x.isNewLine).forEach(x => {
      x.approvalStatus = 'Approved';
      let item = this.validateLineItem(x, true);
    });
  }

  cancelLineCheck() {
    this.associateDataSource.data.filter(x => x.isEditable == true && x.isSelected == true && !x.isNewLine).forEach(x => {
      x.approvalStatus = 'Cancelled';
      x.lineErrors.errors = [];
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { reconcileDataChanged: true, labelNo: 'No, go back to Order Reconciliation' });
    });
    this.disableEnableUpdateBtn();
  }


  enableAllCheckBoxes(isChecked) {
    this.isAllAccountsChecked = isChecked;
    if (isChecked) {
      this.showTabs = true;
      this.showUpdateDiv = true;
      this.associateDataSource.filteredData.filter(x => x.isEditable == true).forEach(x => {
        x.isSelected = true;
      });
      this.checkBoxCount = this.associateDataSource?.filteredData?.filter(x => x.isSelected == true).length;
    }
    else {
      if (this.associateDataSource && this.associateDataSource.filteredData) {
        this.associateDataSource.filteredData.forEach(currentItem => {
          currentItem.orderQty = currentItem.previousQty;
          currentItem.lineErrors.errors = [];
          currentItem.isSelected = false;
          currentItem.approvalStatus = null;
        });
      }

      this.showTabs = false;
      this.showUpdateDiv = false;
      this.isDisableUpdateButton = true;
      this.associateDataSource?.filteredData?.forEach(x => {
        x.isSelected = false;
      });
      this.checkBoxCount = 0;
    }
    if (!this.isAllAccountsChecked) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, {
        updateButtonClick: true
      });
    }
  }

  enableCheckBoxSingle(isChecked, element) {
    if (isChecked) {
      this.showTabs = true;
      this.showUpdateDiv = true;
      this.checkBoxCount = this.associateDataSource.filteredData.filter(x => x.isSelected == true).length;
      this.isAllAccountsChecked = this.checkBoxCount == this.associateDataSource.data.length ? true : false;
    }
    else {
      const uncheckedItem = this.associateDataSource.data.find(x => x.rowId == element.rowId);
      if (uncheckedItem) {
        uncheckedItem.orderQty = uncheckedItem.previousQty;
        uncheckedItem.lineErrors.errors = [];
        uncheckedItem.isSelected = false;
        uncheckedItem.approvalStatus = null;
      }
      this.checkBoxCount = this.checkBoxCount - 1;
      const checked = this.associateDataSource.filteredData.filter(x => x.isSelected == true);
      if (checked && checked.length == 0) {
        this.showTabs = false;
        this.showUpdateDiv = false;
        this.isDisableUpdateButton = true;
      } else {
        this.showUpdateDiv = true;
      }
      this.isAllAccountsChecked = false;
    }
    if (!this.isAllAccountsChecked) {
      this.broadcastService.broadcast(this.configService.DATA_CHANGE, {
        updateButtonClick: true
      });
    }
  }

  onRadioChange(event: any, item: any) {
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { reconcileDataChanged: true, labelNo: 'No, go back to Order Reconciliation' });
    if (item.approvalStatus === 'Approved' && item.orderQty <= 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'approveOrderQty');
      item.lineErrors.errors.push({
        id: 'approveOrderQty', error: 'Quantity must be > 0 to approve this line.'
      });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'approveOrderQty');
    }

    const deltaQty = item.orderQty - item.baseQty;

    if (item.approvalStatus === 'Approved' && item.availableQuantity < deltaQty) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
      item.lineErrors.errors.push({
        id: 'availableUnits', error: 'Order Qty should not be greater than Available Qty'
      });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
    }
    if (item.approvalStatus === 'Cancelled') {
      item.lineErrors.errors = [];
    }

    this.disableEnableUpdateBtn();

  }


  AssociateOrderUnitChange(action: string, productItem: any) {
    if (action === 'decrease') {
      productItem.orderQty = Math.max(0, +productItem.orderQty - 1);
    }
    else if (action === 'increase') {
      productItem.orderQty = +productItem.orderQty + 1;
    }
    if (productItem.orderQty <= 0 && !productItem.isNewLine) {
      productItem.approvalStatus = 'Cancelled';
    }
    this.validateLineItem(productItem, true);
  }

  quantityTextChange(productItem) {
    if (!productItem) {
      return;
    }

    // Allow the user to clear the field while typing — don't force to 0 yet
    if (productItem.orderQty === '' || productItem.orderQty === null || productItem.orderQty === undefined) {
      return;
    }

    // Remove any non-digit characters (appNumbersOnly should prevent these, but be defensive)
    if (typeof productItem.orderQty === 'string') {
      productItem.orderQty = productItem.orderQty.replace(/[^\d]/g, '');
      // remove leading zeros but leave single "0"
      productItem.orderQty = productItem.orderQty.replace(/^0+(\d)/, '$1');
    }

    // If remaining value isn't a number, reset to 0
    // If remaining value isn't a number, reset to 0
    const parsed = Number(productItem.orderQty);
    productItem.orderQty = isNaN(parsed) ? 0 : parsed;
    if (productItem.orderQty <= 0 && !productItem.isNewLine) {
      productItem.approvalStatus = 'Cancelled';
    }
    this.validateLineItem(productItem,true);
  }

  validateLineItem(item: any, isSetDirty: boolean = true) {
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { reconcileDataChanged: true, labelNo: 'No, go back to Order Reconciliation' });
    const deltaQty = item.orderQty - item.baseQty;
    if (!(item.approvalStatus === 'Cancelled') && (item.availableQuantity < deltaQty)) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
      item.lineErrors.errors.push({
        id: 'availableUnits', error: 'Order Qty should not be greater than Available Qty'
      });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'availableUnits');
    }


    if (item.approvalStatus === 'Approved' && item.orderQty <= 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'approveOrderQty');
      item.lineErrors.errors.push({
        id: 'approveOrderQty', error: 'Quantity must be > 0 to approve this line.'
      });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'approveOrderQty');
    }

    this.disableEnableUpdateBtn();
    return item;
  }


  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null &&  this.associateDataSource.data.length > 0) {
      if (element && element != null && isSingleLine) {
        const oldLineValue = this.associateDataSource.data.find(x => x.rowId == element.rowId);
        if (oldLineValue) {
          oldLineValue.orderQty = oldLineValue.previousQty;
          oldLineValue.lineErrors.errors = [];
          oldLineValue.isSelected = false;
          oldLineValue.approvalStatus = null;
        }

      }
      this.checkBoxCount = this.associateDataSource.data.filter(x => x.isSelected == true).length;
      this.isAllAccountsChecked = this.checkBoxCount == this.associateDataSource.data.length ? true : false;

      if (this.checkBoxCount > 0) {
        this.showUpdateDiv = true;
      }
      else {
        this.showUpdateDiv = false;
        this.isDisableUpdateButton = true;
        this.isAllAccountsChecked = false;
        this.showTabs = false;
      }
      if (!this.isAllAccountsChecked) {
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, {
          updateButtonClick: true
        });
      }
    }
    this.disableEnableUpdateBtn();
  }
  bindDataSource(orderList: any) {
    if (orderList && orderList != null) {
      this.associateDataSource.data = orderList;
    }
  }


  // Open Slider Model for Comment
  openAddVarietySliderModel(element) {
    this.loaderService.setLoaderStatus(true);

    const productModelElement = document.querySelector('.product-model');
    if (productModelElement) {
      productModelElement.classList.add('reconcileSlider'); 
    }

    this.subscription.add(
      this.associateCropService.getReconcileVariety(element.orderHeaderID)
        .subscribe((result: any[]) => {
          this.sliderModelService.reconcileVarietySliders(result);
          this.sliderModelService.activeSlider('reconcileVarietySliders');
          this.index = this.associateDataSource?.data?.indexOf(element);
          this.loaderService.setLoaderStatus(false); // hide loader when done
        }, (error) => {
          console.error('Error fetching reconcile varieties', error);
          this.loaderService.setLoaderStatus(false); // hide loader on error
        })
    );
  }

  // Place Associate Order
  addUpdateReconcileOrder() {
    const associateItem = this.associateDataSource.data.filter(x => (x.isNewLine == false && x.previousQty !== x.orderQty) || (x.isNewLine === true && +x.orderQty > 0) || (x.approvalStatus && x.status !== x.approvalStatus)).map(x => ({
      rowId: x.rowId,
      orderHeaderID: x.orderHeaderID,
      locationId: x.locationId,
      cropTypeCode: x.cropTypeCode,
      marketingBrand: x.marketingBrand,
      orderUOM: x.orderUOM,
      orderDetailID: x.orderDetailID,
      variety: x.brand,
      previousQty: x.isNewLine ? 0 : x.previousQty,
      status: x.approvalStatus ? x.approvalStatus : x.status,
      preferredPackagingSize: x.preferredPackagingSize,
      isNewLine: x.isNewLine,
      updatedQty: x.orderQty,
      availbleQty: x.availableQuantity,
      isModifiedLine: true
    }));
    if (this.validateOrderItems(associateItem)) {

      
      this.openConfirmationDialog(associateItem);
    }
  }


  openConfirmationDialog(data) {
    const dialogRef = this.dialog.open(AssociateCropReconciliationConfirmationComponent, {
      width: '750px',
      maxWidth: '90vw',
      disableClose: true,
      panelClass: 'order-dialog',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.action === 'save') {
        this.placeRequest(data);
      }
    });
  }

  placeRequest(associateItem) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.associateCropService.AddUpdateReconcileOrder(associateItem).subscribe((result: any) => {
      if (result && result.length > 0 && result.every(x => x.errors.length == 0)) {
        this.getGridData(true);
        this.toastrService.success('Associate Reconciliation Order Successfully Saved.');
        this.broadcastService.broadcast(this.configService.DATA_CHANGE, {
          updateButtonClick: true

        });
      } else {
        this.associateDataSource.data.forEach(data => {
          data.lineErrors.errors = [];
          const matchedItem = result.find(
            x => x.rowId === data.rowId && x.errors?.length > 0
          );

          if (matchedItem) {
            data.availableQuantity = matchedItem.availbleQty;

            matchedItem.errors.forEach(err => {
              data.lineErrors.errors.push({
                id: err.id,
                error: err.error
              });
            });

          }
        });

        this.loaderService.setLoaderStatus(false);

      }

    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  disableEnableUpdateBtn() {
    const data = this.associateDataSource.data;

    const hasError = data.some(x => x.lineErrors?.errors?.length > 0);
    this.isDisableUpdateButton = hasError || (!(this.associateDataSource.data.some(x =>
      (x.isNewLine == false && x.previousQty !== x.orderQty) ||
      (x.isNewLine === true && +x.orderQty > 0) ||
      (x.approvalStatus && x.status !== x.approvalStatus)
    )));
  }


  validateOrderItems(associateItem) {
    let isValidated = true;
    if (associateItem && associateItem.length > 0) {
      isValidated = true;
      this.associateDataSource.data.forEach(x => {
        if ((x.isNewLine == false && x.previousQty !== x.orderQty) || (x.isNewLine === true && +x.orderQty > 0) || (x.approvalStatus && x.status !== x.approvalStatus)) {
          x = this.validateLineItem(x, false);
          if (x.lineErrors.errors.length > 0) {
            isValidated = false;
          }
        }
      });
    } else {
      isValidated = false;
    }
    return isValidated;
  }


}
export class AssociateOrderLandingFilterVM {
  orderHeaderIdList: number;
  accountNumberList: number;
  accountNameList: any;
  locationNameList: any;
  cropTypeCode: string;
  brandList: string;
  orderFrom: any;
  orderTo: any;
  status: string;
}
